import { apiConnector } from "../apiConnector";
import { toast } from "react-hot-toast";
import { subscriptionEndpoints } from "../apis";

const {
  ACTIVATE_SUBSCRIPTION_API,
  RENEW_SUBSCRIPTION_API,
  EXPIRE_SUBSCRIPTION_API,
  GET_SUBSCRIPTION_BY_ID_API
} = subscriptionEndpoints;

// GET SUBSCRIPTION BY ID
export const getSubscriptionById = async (subscriptionId) => {
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await apiConnector(
      "GET",
      `${GET_SUBSCRIPTION_BY_ID_API}/${subscriptionId}`,
      null,
      { Authorization: `Bearer ${token}` }
    );

    if (response.data.success) {
      return response.data.subscription; // return full details
    }

    toast.error(response.data.message || "Failed to fetch subscription");
    return null;

  } catch (error) {
    console.error("GET SUBSCRIPTION BY ID API ERROR:", error?.response?.data);
    toast.error(error?.response?.data?.message || "Server error");
    return null;
  }
};

// ---------------------------------------------------------------------
// ACTIVATE SUBSCRIPTION (Super Admin Only)
// ---------------------------------------------------------------------
export const activateSubscription = async (data) => {
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await apiConnector(
      "POST",
      ACTIVATE_SUBSCRIPTION_API,
      data,
      { Authorization: `Bearer ${token}` }
    );

    if (response.data.success) {
      toast.success("Subscription activated successfully");
      return response.data.subscription;
    }

    toast.error(response.data.message || "Failed to activate subscription");
    return null;

  } catch (error) {
    console.error("ACTIVATE SUBSCRIPTION API ERROR:", error?.response?.data);
    toast.error(error?.response?.data?.message || "Server error");
    return null;
  }
};

// ---------------------------------------------------------------------
// RENEW SUBSCRIPTION (Super Admin Only)
// ---------------------------------------------------------------------
export const renewSubscription = async (schoolId, newEndDate, apiLimitPerDay) => {
  // console.log("data..",schoolId, newEndDate,apiLimitPerDay)
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await apiConnector(
      "PUT",
      RENEW_SUBSCRIPTION_API,
      { schoolId, newEndDate,apiLimitPerDay },
      { Authorization: `Bearer ${token}` }
    );

    if (response.data.success) {
      toast.success("Subscription renewed successfully");
      return response.data.subscription;
    }

    toast.error(response.data.message || "Failed to renew subscription");
    return null;

  } catch (error) {
    console.error("RENEW SUB API ERROR:", error);
    toast.error(error?.response?.data?.message || "Server error");
    return null;
  }
};

// ---------------------------------------------------------------------
// EXPIRE SUBSCRIPTION (Super Admin Only)
// ---------------------------------------------------------------------
export const expireSubscription = async (schoolId) => {
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await apiConnector(
      "PUT",
      EXPIRE_SUBSCRIPTION_API,
      { schoolId },
      { Authorization: `Bearer ${token}` }
    );

    if (response.data.success) {
      toast.success("Subscription expired successfully");
      return response.data.subscription;
    }

    toast.error(response.data.message || "Failed to expire subscription");
    return null;

  } catch (error) {
    console.error("EXPIRE SUB API ERROR:", error?.response?.data);
    toast.error(error?.response?.data?.message || "Server error");
    return null;
  }
};


